import { useEffect } from 'react';
import {
  faIdCard,
  faList,
  faMapMarkerAlt,
  faSignature,
  faSmile,
} from '~/assets';
import { observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import { showAlert, useGeolocation, useStores } from '~/utils';
import OnboardingIntro from './OnboardingIntro';

const OnboardingIntroContainer = () => {
  const navigate = useNavigate();
  const { user } = useStores();
  const {
    latitude,
    longitude,
    altitude,
    accuracy,
    error,
    loading,
    isValidLocation,
    requestUserLocation,
  } = useGeolocation();

  const steps = [
    {
      icon: faList,
      description: 'Confirmar seus dados',
    },
    {
      icon: faMapMarkerAlt,
      description: 'Informar seu endereço',
    },
    {
      icon: faSmile,
      description: 'Biometria facial',
    },
    {
      icon: faIdCard,
      description: 'Documento de identificação com foto',
    },
    {
      icon: faSignature,
      description: 'Assinatura do contrato',
    },
  ];

  const handleNext = () => {
    if (loading || error) {
      showAlert({
        message: 'Você deve permitir o acesso à sua localização para continuar',
        type: 'warning',
      });
      return;
    }
    navigate(Routes.ONBOARDING_PHONE);
  };

  const handleUserLocationRequest = async () => {
    await requestUserLocation();
    if (loading) return;
    if (isValidLocation()) {
      user.setGeoLocationData({
        latitude,
        longitude,
        altitude,
        accuracy,
      });
    }
    if (error) {
      navigate(Routes.ERROR_SCENE, {
        state: {
          title: 'Localização bloqueada',
          subtitle:
            'Para continuar, você precisa permitir o acesso à sua localização nas configurações do seu navegador e clicar no botão "TENTAR NOVAMENTE".',
          primaryButtonText: 'TENTAR NOVAMENTE',
          primaryButton: 'goToOnboardingIntro',
        },
      });
    }
  };

  useEffect(() => {
    handleUserLocationRequest();
  }, [latitude, longitude, altitude, accuracy, error, loading]);

  return <OnboardingIntro steps={steps} handleNext={handleNext} />;
};

export default observer(OnboardingIntroContainer);
